// extracted by mini-css-extract-plugin
export default {"container":"CategorySeperator_container__ErePo"};